import { FC } from 'react'

import { SkeletonPlaceholder } from 'components/SkeletonPlaceholder'

export const ReferenceSkeleton: FC = () => (
  <div className="flex w-full flex-col gap-y-4 p-6" role="progressbar">
    <SkeletonPlaceholder size="xl" />
    <SkeletonPlaceholder size="xl" />
    <SkeletonPlaceholder size="md" />
  </div>
)
